(() => {
  const state = {"signature": "0rzqeh-wu", "family": "blenderbottle", "historyRevision": 3, "styleKind": "pulse"};

  const apply = () => {
    const root = document.documentElement;
    root.dataset.codexCodeRuntime = state.signature;
    root.dataset.codexCodeRuntimeFamily = state.family;
    root.dataset.codexCodeRuntimeHistory = "r" + state.historyRevision;
    root.style.setProperty("--codex-code-runtime-token", "355");
    root.style.setProperty("--codex-code-runtime-family-token", "424");
    root.style.setProperty("--codex-code-runtime-history-revision", "3");
    window.__CODEX_THEME_SIGNATURE__ = state;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply, { once: true });
  } else {
    Promise.resolve().then(apply);
  }
})();
